import Admin from './admin'

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    Admin.state
  ),
  mutations: Object.assign(
    Admin.mutations
  )
}



// WEBPACK FOOTER //
// ./src/store/admin/index.js